import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { CircularLoader } from '@blade/ui-kit'
import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { UserTradingAnalyticsPriceType } from '@root/features/user/user-trading-analytics/models/user-trading-analytics-price-type'

export const PnlChartLoading: React.FC<{
  priceType?: UserTradingAnalyticsPriceType
}> = ({ priceType = UserTradingAnalyticsPriceType.USD }) => {
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)

  const labels =
    priceType === UserTradingAnalyticsPriceType.NATIVE
      ? ['10', '1', '0', '-1', '-10'].map(
          (v) => `${v} ${nativeCurrency.ticker}`,
        )
      : ['$100', '$10', '$0', '-$10', '-$100']

  return (
    <Root>
      <Col>
        <DottedLine />
        <DottedLine />
        <CentralLine>
          <Line />
          <CircularLoader size={24} />
          <Line />
        </CentralLine>
        <DottedLine />
        <DottedLine />
      </Col>
      <Col>
        {labels.map((text) => (
          <Volume key={text}>{text}</Volume>
        ))}
      </Col>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  padding: 10px 10px 22px 10px;
`

const CentralLine = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 10px;
  place-items: center;
`

const Line = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: 1.6px solid var(--background-3);
`

const DottedLine = styled(Line)`
  border-bottom: 1px dashed var(--background-3);
`

const Col = styled.div`
  display: grid;
  place-items: center;
`

const Volume = styled.span`
  color: var(--textA-5);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
`
